import { Node } from '@tiptap/pm/model'
import { Editor, NodeViewWrapper } from '@tiptap/react'
import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import { cn } from '../../../lib/utils/index.js'
import VideoPlayer from './videojs/VideoPlayer.js'

interface VideoBlockViewProps {
  editor: Editor
  getPos: () => number
  node: Node & {
    attrs: {
      src: string
      poster: string
      assetId: string
      playlistUrl?: string
    }
  }
  updateAttributes: (attrs: Record<string, string>) => void
}

export const NewVideoBlockView = (props: VideoBlockViewProps) => {
  const { editor, getPos, node } = props
  const videoWrapperRef = useRef<HTMLDivElement>(null)
  const { src, poster, optimizedImageUrl, playlistUrl, caption, title } = node.attrs

  const [error, setError] = React.useState('')

  const wrapperClassName = cn(
    node.attrs.align === 'left' ? 'ml-0' : 'ml-auto',
    node.attrs.align === 'right' ? 'mr-0' : 'mr-auto',
    node.attrs.align === 'center' && 'mx-auto',
  )

  const onClick = useCallback(() => {
    editor.commands.setNodeSelection(getPos())
  }, [getPos, editor.commands])

  const videoJsOptions = useMemo(() => {
    return {
      sources: playlistUrl,
      ...((poster || optimizedImageUrl) && { poster: poster || optimizedImageUrl }),
    }
  }, [])
  return (
    <NodeViewWrapper>
      <div className={wrapperClassName} style={{ width: node.attrs.width }}>
        <div ref={videoWrapperRef}>
          {error && <div>{error}</div>}
          {/* <video
            controls
            className="block"
            src={src}
            poster={poster}
            title=""
            onClick={onClick}
          /> */}
          {playlistUrl && <VideoPlayer options={videoJsOptions} />}
          {caption && (
            <caption className="text-center block text-sm text-gray-500">
              {title || caption}
            </caption>
          )}
        </div>
      </div>
    </NodeViewWrapper>
  )
}

export default NewVideoBlockView
